/**
 * Базовый URL сервера для /uploads (картинки с API не с origin :3000).
 */
export function getUploadsBaseUrl(apiUrl) {
  const u =
    apiUrl ||
    (typeof process !== 'undefined' && process.env?.REACT_APP_API_URL) ||
    'http://localhost:5000/api';
  const trimmed = String(u).trim();
  if (/^https?:\/\//i.test(trimmed)) {
    return trimmed.replace(/\/?api\/?$/i, '').replace(/\/$/, '') || trimmed;
  }
  const fromEnv =
    (typeof process !== 'undefined' && process.env?.REACT_APP_SERVER_ORIGIN) ||
    (typeof process !== 'undefined' && process.env?.REACT_APP_UPLOADS_ORIGIN);
  if (fromEnv) return String(fromEnv).replace(/\/$/, '');
  if (typeof window !== 'undefined') {
    const { protocol, hostname } = window.location;
    return `${protocol}//${hostname}:5000`;
  }
  return 'http://localhost:5000';
}

export function uploadsAbsoluteUrl(path, apiUrl) {
  if (!path) return '';
  const p = String(path);
  if (p.startsWith('http://') || p.startsWith('https://')) return p;
  const base = getUploadsBaseUrl(apiUrl);
  return `${base}${p.startsWith('/') ? p : `/${p}`}`;
}
